<template>
  <button class="submit-button" type="submit">
    <div>
      <img src="../../../public/images/button_login-01.svg" />
    </div>
  </button>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    label: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.submit-button {
  border: 0;
  padding: 0;
  background: none;
  flex-basis: 100%;
  display: flex;
  text-align: right;
  justify-content: flex-end;
  cursor: pointer;
  div {
    width: 40%;
    height: 40%;
  }
}

@media print {
  .submit-button {
    display: none;
  }
}
</style>
